export default {"src":"/planos/_next/static/media/equifax-target.dbd46195.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};